<script setup>
import { computed } from 'vue';
import ButtonBase from '../buttons/buttonBase.vue';
import { captchaGate } from '../../stores/captchaGate.js';

const props = defineProps({
    solved: {
        type: Boolean,
        default: null,
    },
});

// A primary submit button that stays disabled until the shared captcha gate is
// solved (see TurnstileFrame.vue). Reading the gate through a computed here means
// the dependency is tracked in this component's own render, so it reliably
// re-enables the moment a Turnstile token arrives. When no captcha is present the
// gate defaults to solved, so the button behaves like a normal primary button.
const disabled = computed(() => props.solved === null ? !captchaGate.solved : !props.solved);
</script>

<template>
    <button-base style-type="primary" type="submit" :disabled="disabled">
        <slot></slot>
    </button-base>
</template>
